import { useContext } from "react";
import { QuoteContext } from "./QuotesList";

/**
 * Retrieves the optional quote context from the current component hierarchy.
 *
 * @returns {object} The quote context object if it exists, otherwise a default context object.
 * @throws {Error} If the quote context is not provided.
 */
const useOptionalQuoteContext = () => {
  try {
    const context = useContext(QuoteContext);
    if (context === undefined) {
      throw new Error("QuoteContext not provided");
    }
    return context;
  } catch (e) {
    return {
      quotes: [],
      setQuotes: () => {},
    };
  }
};

export default useOptionalQuoteContext;
